import { Box } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

import { NotificationContainer } from '@/modules/notifications/NotificationContainer/NotificationContainer';
import { COLORS } from '@/styles/tokens/colors';

import { AppBar, AppBarProps } from './AppBar';
import { AppBarMenuItems } from './AppBarMenuItems';
import { TrialBanner } from './TrialBanner';

const useStyles = makeStyles()((theme) => ({
  toolBar: {
    backgroundColor: COLORS.GRAY[700],
    paddingLeft: theme.spacing(1.5),
    paddingRight: theme.spacing(1.5),
  },
}));

export function PrimaryAppBar(props: AppBarProps) {
  const { classes } = useStyles();

  return (
    <AppBar
      classes={{
        toolBar: classes.toolBar,
      }}
      {...props}
    >
      <NotificationContainer variant="light" />
      <Box flexGrow={1} />
      <TrialBanner />
      <AppBarMenuItems />
    </AppBar>
  );
}
